import type React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import Approval from '@mui/icons-material/Approval';
import AssignmentInd from '@mui/icons-material/AssignmentInd';
import Build from '@mui/icons-material/Build';
import BugReportOutlined from '@mui/icons-material/BugReportOutlined';
import Construction from '@mui/icons-material/Construction';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import Engineering from '@mui/icons-material/Engineering';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Inventory2 from '@mui/icons-material/Inventory2';
import LocalShipping from '@mui/icons-material/LocalShipping';
import ShieldOutlined from '@mui/icons-material/ShieldOutlined';
import { WorkflowStageIcon } from 'shared/domain/workflow/types';

export const STAGE_ICON_MAP: Record<WorkflowStageIcon, React.ComponentType<SvgIconProps>> = {
  [WorkflowStageIcon.description]: DescriptionOutlined,
  [WorkflowStageIcon.assignment]: AssignmentInd,
  [WorkflowStageIcon.build]: Build,
  [WorkflowStageIcon.bugReport]: BugReportOutlined,
  [WorkflowStageIcon.security]: ShieldOutlined,
  [WorkflowStageIcon.info]: InfoOutlined,
  [WorkflowStageIcon.checkCircle]: Approval,
  [WorkflowStageIcon.inventory]: Inventory2,
  [WorkflowStageIcon.localShipping]: LocalShipping,
  [WorkflowStageIcon.engineering]: Engineering,
  [WorkflowStageIcon.construction]: Construction,
};
